import React from "react";
import {Navigate, useSearchParams} from "react-router-dom";
import {useSelector} from "react-redux";
import stringHelper from "../helpers/string-helper";

const ProtectedRoute = ({children, isPublic}) => {


    const {authenticated} = useSelector(state => state.authenticationReducer)
    const [searchParams, setSearchParams] = useSearchParams()


    if (!isPublic && !authenticated) {
        // store.dispatch(GLOBAL_ACTIONS.setModalTypeAction('login'))
        return <Navigate to={stringHelper.getModalPath('modal', 'login',searchParams)} replace/>;
    }

    // if (authenticated || !user?.email_verified_at)
    //     return <Navigate to="/" replace/>;


    return children;
};


export default ProtectedRoute
